export enum LsKeys {
  TOKEN_INFO = 'token-info',
}
